import React from "react";
import { useTranslation } from "react-i18next";
import DashboardHeader from "../../../../components/dashboard/dashboardHeader";
import { DeviationNotificationSettingsForm } from "../../../../components/dashboard/quality/deviations/DeviationNotificationSettingsForm";

export const DeviationNotificationSettings = () => {
  const { t } = useTranslation();

  return (
    <DashboardHeader
      title={t("deviation.settings.title")}
      subtitle={t("deviation.settings.subtitle")}
      backUrl="/dashboard/hse-ks/deviations"
    >
      <div className="bg-[#F6F8FB] p-4 sm:p-6">
        <DeviationNotificationSettingsForm />
      </div>
    </DashboardHeader>
  );
};
